import styled from '@emotion/styled';
import { Fonts } from '@styles/index';

const HTMLWrapper = styled.div`
  color: var(--color-text-primary);

  u {
    text-decoration: underline;
  }

  p,
  li {
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    color: var(--color-text-primary);
  }

  img {
    max-width: 100%;
  }

  ${({ $isImageClickable }) => {
    if ($isImageClickable) {
      return `
      img {
        cursor: pointer;
      }
      img[data-latex='true'] {
        cursor: inherit;
      }
      `;
    }
  }}
`;

export default HTMLWrapper;
